import { request } from '../../helpers'

export default {
  async getCustomerFields({ queryParameters = {} } = {}) {
    return (
      await request({
        url: 'customer_fields',
        queryParameters,
      })
    ).data
  },
  async submitLeadForm(id, { data = {}, headers = {} } = {}) {
    return (
      await request({
        method: 'POST',
        url: `crm/lead_forms/${id}/submit`,
        data,
        headers,
      })
    ).data
  },
}
